import { TimeSelectField as TimeSelectFieldBase } from '../base/TimeField';
import createField from './createField';

const TimeSelectField = createField(TimeSelectFieldBase);

export default TimeSelectField;
